export const location = [
  {
    label: 'Hyderabad',
    value: 'Hyderabad',
  },
  {
    label: 'Noida',
    value: 'Noida',
    selected: false,
  },
  {
    label: 'Gurugram',
    value: 'Gurugram',
  },
];

export const validFileTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];